module.exports = __webpack_public_path__ + "static/img/app-info-demo-txs@2x.726cb99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-info-demo-txs@2x.png
// module id = phyp
// module chunks = 1